import { createNamedContext } from '@trinity/chat-components/utils';
import type {
  BrandThemingContextValue,
  FetchBrandThemingContextValue,
  SurveyThemingContextValue,
  WhitelabelingPaletteContextValue,
} from './interfaces';

export const BrandThemingContext = createNamedContext<BrandThemingContextValue>(
  undefined,
  'Branding.Theming.Context'
);

export const WhitelabelingPaletteContext = createNamedContext<WhitelabelingPaletteContextValue>(
  undefined,
  'Branding.WhitelabelingPalette.Context'
);

export const SurveyThemingContext = createNamedContext<SurveyThemingContextValue>(
  undefined,
  'Branding.SurveyTheming.Context'
);

export const FetchBrandThemingContext = createNamedContext<FetchBrandThemingContextValue>(
  async () => ({
    theming: {
      palettes: [],
      themes: [],
    },
  }),
  'Branding.FetchTheming.Context'
);
export const FetchWhitelabelingPaletteContext = createNamedContext<
  () => Promise<WhitelabelingPaletteContextValue>
>(undefined, 'Branding.FetchWhitelabelingPalette.Context');
